<template>
    <div v-on:dblclick="onDoubleClick" class="inline-image">
        <file-modal-component
            v-on:change="updateValue"
            :show="showModal"
            :value="_.get(initialValue, 'id')"
            :closeModal="closeModal"
            :extensions="schema.extensions"
            ></file-modal-component>
        <img :src="_.imgPath(initialValue, 'w80')"
            :style="css" />
    </div>
</template>
<script>
import Vue from 'vue';
import FileModalComponent from '../helpers/FileModalComponent';

export default {
    data() {
        return {
            value: this.initialValue,
            showModal: false,
        }
    },

    components: {
        FileModalComponent,
    },

    props: ['initialValue', 'css', 'schema'],

    watch: {

    },

    mounted() {

    },

    methods: {
        onDoubleClick() {
            this.showModal = true;
        },

        updateValue(val) {
            this.$emit('change', val);
            this.showModal = false;
        },

        closeModal() {
            this.showModal = false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/InlineImageComponent.vue